/*
 * @Author: JinpengFeng
 * @Date: 2021-01-12 18:15:27
 * @LastEditTime: 2021-01-21 10:20:16
 * @Description: search title store
 * @LastEditors: JinpengFeng
 */
import S from "service";
import * as types from "../mutation-types";

const state = {
	hotLabels: [], // 热门标签
	labels: [], // 搜索结果标签
	selectedLabel: {}, // 选中的标签
	searchName: "", // 搜索的课程名称
};

const getters = {
	hotLabels(state) {
		return state.hotLabels;
	},
};

const mutations = {
	[types.SET_HOTLABELS](state, payload) {
		state.hotLabels = payload;
	},
	[types.UPDATE_LABELS](state, payload) {
		state.labels = payload;
	},
	[types.SET_SELECTEDLABEL](state, payload) {
		state.selectedLabel = payload;
	},
	[types.SET_SEARCHNAME](state, payload) {
		state.searchName = payload;
	},
};

const actions = {
	getHotLabels({ commit, state }, payload) {
		S.getHotSearchWords({}, { loading: false }).then(res => {
			commit(types.SET_HOTLABELS, res);
		});
	},
	getLabels({ commit, state }, payload) {
		S.getRelateSearch({ name: payload.name }, { loading: false }).then(res => {
			commit(types.UPDATE_LABELS, res);
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
